import React from 'react';

/** The PWA's own status line: clock left, sync and battery right. */
export function StatusRow({ time = '9:41', queued = 0, battery = '87%', offline = false, style }) {
  const alert = offline || queued > 0;
  return (
    <div style={{
      height: 44, flex: 'none', display: 'flex', alignItems: 'flex-end',
      justifyContent: 'space-between', padding: '0 22px 5px',
      font: 'var(--bujo-fw-medium) var(--bujo-fs-micro)/var(--bujo-lh-tight) var(--bujo-font-mono)',
      color: 'var(--bujo-text-meta)', ...style
    }}>
      <span>{time}</span>
      <span style={{ color: alert ? 'var(--bujo-state-queued)' : 'var(--bujo-text-meta)' }}>
        &#8961; {offline ? 'OFFLINE' : 'QUEUED ' + queued} &middot; {battery}
      </span>
    </div>
  );
}
